import { styled } from "@mui/material/styles";

// Components
import { TextField as MTextField } from "@mui/material";

// Themes
import theme from "../Theme";

const styledName = "TextInput";
// Styles
export const StyledInput = styled(MTextField, { name: styledName })({
  "&": {
    ".MuiInputBase-root": {
      fontSize: "1.4rem",
      backgroundColor: "white",
      border: "none",
      height: "40px",
      borderRadius: "6px",

      "&::before": {
        borderBottom: `2px solid ${theme.palette.primary.dark} !important`,
      },
    },
    ".MuiOutlinedInput-root": {
      "& fieldset": {
        transition: "all 0.3s ease-in",
        border: "solid 1px transparent",
      },
      "&:hover fieldset": {
        border: "solid 1px",
        borderColor: theme.palette.primary.main,
      },
    },
  },
});
